import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useAuthStore } from '../store/authStore';
import BrandLogo from './BrandLogo';

function AppHeader({ rightContent = null, showLogout = true }) {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <button type="button" onClick={() => navigate('/dashboard')}>
        <BrandLogo />
      </button>

      {rightContent ? (
        rightContent
      ) : showLogout ? (
        <button
          type="button"
          onClick={handleLogout}
          className="inline-flex items-center gap-2 rounded-[12px] border border-[#d7dce2] px-4 py-2 font-login text-[14px] font-semibold text-[#243041] transition hover:bg-[#f7f9fc]"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
      ) : null}
    </div>
  );
}

export default AppHeader;
